import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';

import { TabControlComponent } from '../../../shared/controls/tab-control/tab-control.component';
import { TabPageComponent } from '../../../shared/controls/tab-control/tab-page.component';
import { ClientAreaReportComponent } from './client-area-report/client-area-report.component';
import { EndorsementComponent } from './client-area-endorsement/client-area-endorsement.component';
import { ClientAreaDetailComponent } from './client-area-detail/client-area-detail.component';

import { ClientAreaService, ClientService } from '../../../../service/proxy';
import { ErrorService } from '../../../shared/services/error-service';

@Component({
    selector: 'create-or-update-client-area',
    templateUrl: './create-or-update-client-area.component.html',
    styleUrl: './create-or-update-client-area.component.scss',

    imports: [
        CommonModule,
        FormsModule,
        EndorsementComponent,
        ClientAreaReportComponent,
        ClientAreaDetailComponent,
        TabControlComponent,
        TabPageComponent
    ],

    providers: [
        ClientService,
        ClientAreaService,
        ErrorService
    ]
})
export class CreateOrUpdateClientAreaComponent implements OnInit {
    policyId: number = 0;
    clientId: number = 0;

    public activeTab: string = 'Policy Details';

    client: any;
    clientArea: any;

    constructor(
        private route: ActivatedRoute,
        private router: Router,
        private clientService: ClientService,
        private clientAreaService: ClientAreaService,
        private errorService: ErrorService
    ) {};

    ngOnInit(): void {
        this.route.paramMap.subscribe(params => {
            this.policyId = Number(params.get('policyId'));
            this.clientId = Number(params.get('clientId'));
        });

        this.route.queryParams.subscribe(params => {
            const tab = params['tab'];

            if (tab === 'endorsements') {
                this.activeTab = 'Endorsements';
            }
            else if (tab === 'reports') {
                this.activeTab = 'Reports';
            }
            else {
                this.activeTab = 'Policy Details';
            }
        });

        this.getClientById();
        this.getClientAreaById();
    }

    getClientById(): void {
        this.clientService.getClientById(this.clientId)
            .subscribe({
                next: (result) => {
                    this.client = result.clientName;
                },
                error: (error) => {
                    this.errorService.handleError(error);
                }
            });
    }

    getClientAreaById(): void {
        if (this.clientId === 0 || this.policyId === 0) {
            return;
        }

        this.clientAreaService.getClientAreaById(this.policyId)
            .subscribe({
                next: (result) => {
                    this.clientArea = result.areaName;
                },
                error: (error) => {
                    this.errorService.handleError(error);
                }
            });
    }

    backToClientDetails(): void {
        this.router.navigate([`/client/${this.clientId}`]);
    }
}